<template>
  <div class="row doc_concursos" v-if="files.length > 0">
    <div class="small-11 medium-12 large-10 columns">
      <div class="row">
        <Document class="small-12 medium-3 large-3 columns aviso"
          v-for="file in files" :key="file.doc_ficheiros_url"
          :nome="file.doc_ficheiros_nome" :url="file.doc_ficheiros_url" />
      </div>
    </div>
  </div>
</template>

<script>
import Document from '@/components/Document.vue';

export default {
  props:["files"],
  components:{
    Document
  },
  setup() {


    return {}
  }
}
</script>

<style lang="scss" scoped>
.row .row.doc_concursos {
    margin-left: 38px;
    margin-bottom: 60px;
}

.aviso{
  margin-bottom: 10px;
  margin-right: 10px;
}

@media (max-width:850px) {
  .aviso{
    flex: 30.333%;
    max-width: 30.333%;
  }
}

@media (max-width:767px) {

  .small-11{
    padding-left: 0;
    padding-right: 0;
  }

  .aviso{
    margin-bottom: 0;
    margin-right: 0;
    flex: 0 0 100%;
    max-width: 100%;
  }

  .row .row.doc_concursos {
    margin-left: 18px;
    margin-right: 0;
    padding-right: 20px;
    margin-top: 15px;
  }
}
</style>